module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[2]245.0808c24.woff2";